import emailjs from '@emailjs/browser';
import React from 'react';
import { useRef } from "react";
import './Formular.css'
 
export const Formular = () => {

    const form = useRef();

    function sendEmail(e) {
        e.preventDefault();

    emailjs.sendForm('service_56784a4', 'template_uviiiih', form.current, 'z96OnzGHOikWAiCr6')
        .then((result) => {
            console.log(result.text);
        }, (error) => {
            console.log(error.text);
        });
        e.target.reset()
    }


  return (
    <div>
      <form ref={form} onSubmit={sendEmail}>
      <div className="body6-box3">Napište nám</div>
        <div className="body6-box5"><div className="body6-box4"></div></div>
              <div className="kontakt-box-formular-grid">
                  <div className="kontakt-box-formular-grid-1">
                      <input type="text" className="kontakt-box-formular-grid-1-text" placeholder="&nbsp;&nbsp;Jméno a Příjmení" name="name"/>
                  </div>
                  <div className="kontakt-box-formular-grid-2">
                      <input type="email" className="kontakt-box-formular-grid-2-text" placeholder="&nbsp;&nbsp;Vaše emailová adresa" name="email"/>
                  </div>
                  <div className="kontakt-box-formular-grid-3" >
                    <select className="kontakt-box-formular-grid-3-text" name="subject" type="subject">
                      <option name="subject" value="Cenová nabídka">&nbsp;&nbsp;Cenová nabídka</option>
                      <option name="subject" value="Všeobecný dotaz">&nbsp;&nbsp;Všeobecný dotaz</option>
                    </select>
                  </div>
                  <div className="kontakt-box-formular-grid-4">
                      <textarea className="kontakt-box-formular-grid-4-text" placeholder="&nbsp;&nbsp;Napište nám zprávu" name="message"></textarea>
                  </div>
                  <div className="kontakt-box-formular-button">
                  <div className="button3">
                  <input type="submit" className="kontakt-box-button" value="Odeslat"></input>
                  </div>
                  </div>
              </div>
      </form>
    </div>

  );
}

export default Formular;

